import React from 'react';
import Modal from '../../common/Modal';
import SelectableCard from '../../common/SelectableCard';
import { useLanguage } from '../../../context/LanguageContext';
import { translateDynamic } from '../../../context/LanguageContext';

const ChangeTableModal = ({
    isOpen,
    onClose,
    orderToChangeTable,
    pendingOrders,
    diningOptions,
    availableTableNumbers,
    newDiningOption,
    setNewDiningOption,
    newTableNumber,
    setNewTableNumber,
    onConfirm,
    confirmDisabled,
    confirmLabel,
}) => {
    const { t } = useLanguage();

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={t('change_table')}
            footer={(
                <>
                    <button
                        type="button"
                        className="inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
                        onClick={onClose}
                    >
                        {t('cancel')}
                    </button>
                    <button
                        type="button"
                        className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-primary-600 border border-transparent rounded-md shadow-sm hover:bg-primary-700"
                        onClick={onConfirm}
                        disabled={confirmDisabled}
                    >
                        {confirmLabel || t('change_table')}
                    </button>
                </>
            )}
        >
            {orderToChangeTable && pendingOrders[orderToChangeTable] && (
                <div>
                    <p>{t('move_order_from')} {pendingOrders[orderToChangeTable].diningOption} {pendingOrders[orderToChangeTable].tableNumber} {t('to_new_table')}:</p>

                    {/* Dining Option Selection */}
                    <div className="mt-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            {t('select_dining_option')}
                        </label>
                        <div className="grid grid-cols-2 gap-2">
                            {diningOptions.filter(option => {
                                const diningConfig = availableTableNumbers[option];
                                return Array.isArray(diningConfig);
                            }).map(option => (
                                <SelectableCard
                                    key={option}
                                    label={translateDynamic(option, t)}
                                    selected={newDiningOption === option}
                                    onClick={() => {
                                        setNewDiningOption(option);
                                        setNewTableNumber('');
                                    }}
                                />
                            ))}
                        </div>
                    </div>

                    {/* Table Selection */}
                    {newDiningOption && availableTableNumbers[newDiningOption] !== undefined && availableTableNumbers[newDiningOption] !== "" && (
                        <div className="mt-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                {t('select_new_table')}
                            </label>
                            {availableTableNumbers[newDiningOption] === "random_number" ? (
                                <input
                                    type="text"
                                    value={newTableNumber}
                                    onChange={(e) => setNewTableNumber(e.target.value)}
                                    placeholder={`${t('enter')} ${translateDynamic(newDiningOption, t)} ${t('number')}`}
                                    className="shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                />
                            ) : (
                                <div className="grid grid-cols-5 gap-2">
                                    {Array.isArray(availableTableNumbers[newDiningOption]) &&
                                        availableTableNumbers[newDiningOption].map(num => {
                                            const newTableKey = `${newDiningOption}-${num}`;
                                            const isTableInUse = Object.keys(pendingOrders).includes(newTableKey);
                                            const isCurrentTable = pendingOrders[orderToChangeTable].diningOption === newDiningOption &&
                                                pendingOrders[orderToChangeTable].tableNumber === num.toString();
                                            return (
                                                <SelectableCard
                                                    key={num}
                                                    label={`${typeof num === 'string' ? num : `Table ${num}`}${isTableInUse ? ' (In Use)' : ''}`}
                                                    selected={newTableNumber === num.toString()}
                                                    onClick={() => !isTableInUse && !isCurrentTable && setNewTableNumber(num.toString())}
                                                    disabled={isTableInUse || isCurrentTable}
                                                />
                                            );
                                        })
                                    }
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}
        </Modal>
    );
};

export default ChangeTableModal;
